import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faMoneyCheck,
  faUsers,
  faMapPin,
  faFileCsv,
  faLock,
  faQuestionCircle,
  faCopy,
  faComment,
  faTimes
} from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  far,
  faMoneyCheck,
  faUsers,
  faMapPin,
  faFileCsv,
  faLock,
  faQuestionCircle,
  faCopy,
  faComment,
  faTimes
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
